<div class="pr-4 pl-4 pb-8">
    <div class="bg-blue-100 p-3 flex justify-content-between items-center rounded mt-3">
    <span class="font-bold">New Status:</span>
    <span class="font-bold">{{selectedStatus}}</span>
    </div>
    <p class="upload-warning mt-3">{{dataInput.info}}</p>
    <div class="flex flex-column w-4 mb-2">
        <label class="mb-3" for="selectedDate" matTooltip="Info about the action"><span class="red-color">*</span>{{dataInput.dateLabel}}:</label>
        <p-calendar [showIcon]="true"
                    class="custom-calendar"
                    id="selectedDate"
                    [iconDisplay]="'input'" 
                    [minDate]="minDate"
                    [(ngModel)]="detailsDto.selectedDate"
                    inputId="buttondisplay"
                    [showOnFocus]="false" />
    </div>
    <div class="flex flex-column mt-3">
        <div *ngFor="let radio of dataInput.radio" class="flex align-items-center w-4 mb-3">
            <p-radioButton 
                [value]="radio.value"
                [disabled]="radio.disabled"
                [(ngModel)]="detailsDto.type"
                (ngModelChange)="formChanged()" />
            <label class="ml-2">
                {{radio.label}}
            </label>
        </div>
    </div>

    <div class="flex flex-row">
        <div class="flex flex-column w-6 mr-3">
            <label class="mb-3" for="reason"><span class="red-color">*</span>Reason:</label>
            <p-dropdown 
                id="reason"
                [options]="dataInput.reason"
                (onChange)="formChanged()"
                [(ngModel)]="detailsDto.reason"
                optionValue="name"
                optionLabel="name"
                placeholder="Select Reason" />
        </div>
        <div *ngIf="detailsDto.reason ===  'Others'" class="flex flex-column w-6">
        <label class="mb-3" for="specify"><span class="red-color">*</span>Please specify:</label>
            <input class="input-profile" 
                    [(ngModel)]="detailsDto.specificReason" 
                    type="text" pInputText 
                    placeholder="Please specify"
                    (keyup)="formChanged()">
        </div>
    </div>

    <div class="flex flex-column mt-3">
        <label class="mb-3" for="remarks">Remarks:</label>
        <textarea 
            id="remarks"
            rows="3"
            cols="30" 
            pInputTextarea 
            [(ngModel)]="detailsDto.remarks"
            placeholder="Enter Remarks here"
            [autoResize]="true">
        </textarea>
</div>
</div>
